
export default class NumberUtil {
  static _FORMATTER = Intl.NumberFormat('de-CH', {minimumFractionDigits: 0, maximumFractionDigits: 0});
  static _PERCENT_FORMATTER = Intl.NumberFormat('de-CH', {minimumFractionDigits: 0, maximumFractionDigits: 2});
  static _UNIT_PREFIX = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'E', 'Z', 'Y', 'R', 'Q']


  static format(value) {
    const num = Number(value)
    if (isNaN(num)) {
      return value
    }
    return NumberUtil._FORMATTER.format(num);
  }

  static percent(value) {
    const num = Number(value)
    if (isNaN(num)) {
      return value
    }
    return NumberUtil._PERCENT_FORMATTER.format(num)
  }

  static reduce(value, unit = '') {
    let num = Number(value)
    if (isNaN(num)) {
      return value
    }
    let index = 0
    while (num > 1000 || num < -1000) {
      num /= 1000
      index++
    }
    return `${num.toFixed(2)} ${NumberUtil._UNIT_PREFIX[index]}${unit}`
  }
}
